export default __webpack_public_path__ + "static/student-e89efa1ac2b15521381bd823c110414d.jpg";